var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-list-group",
        { attrs: { flush: "" } },
        [
          _c(
            "b-list-group-item",
            [
              _c("b-skeleton", {
                staticClass: "mt-2",
                attrs: { animation: "fade", width: "20%" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-list-group-item",
            [
              _c(
                "b-col",
                { staticClass: "mx-0", attrs: { lg: "10" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "moregage-form" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("b-skeleton", {
                            staticClass: "mt-2",
                            attrs: { animation: "fade", width: "50%" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "moregage-form" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            { staticClass: "form-group-material" },
                            [
                              _c("b-skeleton", {
                                staticClass: "mt-2",
                                attrs: { animation: "fade", width: "50%" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "moregage-form align-items-center" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            { staticClass: "form-group-material" },
                            [
                              _c("b-skeleton", {
                                staticClass: "mt-2",
                                attrs: { animation: "fade", width: "50%" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }